import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.basic');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'wiz-page-basic',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.basic/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageBasicComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public category: string = '';
    public sub: string = '';
    public routerSub: any;

    // 매장정보
    public storeData: any = {};

    // 사원
    public employees: any[] = [];
    public empTotal: number = 0;
    public empPage: number = 1;
    public empSearch: string = '';
    public empForm: any = {};
    public empEditing: boolean = false;

    // 패스워드
    public pwForm: any = { current: '', newpw: '', confirm: '' };

    // 상품분류
    public catLevel1: any[] = [];
    public catLevel2: any[] = [];
    public catLevel3: any[] = [];
    public selectedCat1: string = '';
    public selectedCat2: string = '';
    public catForm: any = {};

    // 브랜드
    public brands: any[] = [];
    public brandForm: any = {};

    // 거래처
    public suppliers: any[] = [];
    public supplierTotal: number = 0;
    public supplierPage: number = 1;
    public supplierSearch: string = '';
    public supplierForm: any = {};
    public supplierEditing: boolean = false;

    // 상품
    public products: any[] = [];
    public productTotal: number = 0;
    public productPage: number = 1;
    public productSearch: string = '';
    public productForm: any = {};
    public productEditing: boolean = false;

    // 판매가관리
    public priceProducts: any[] = [];
    public priceTotal: number = 0;
    public pricePage: number = 1;
    public priceSearch: string = '';
    public priceEditingId: string = '';
    public priceEditValue: number = 0;

    // 결제수단
    public payments: any[] = [];
    public paymentForm: any = {};
    public paymentEditing: boolean = false;
    public activePaymentType: string = 'card';

    // 명칭관리
    public codeGroups: any[] = [];
    public codeItems: any[] = [];
    public selectedCodeGroup: string = '';
    public codeForm: any = {};
    public codeEditing: boolean = false;

    // 예약관리
    public reservations: any[] = [];
    public reservationTotal: number = 0;
    public reservationPage: number = 1;
    public reservationDate: string = '';
    public reservationStatus: string = '';
    public reservationForm: any = {};
    public reservationEditing: boolean = false;

    // 주방메모관리
    public kitchenMemos: any[] = [];
    public kitchenMemoForm: any = {};
    public kitchenMemoEditing: boolean = false;

    // 배달구역관리
    public deliveryZones: any[] = [];
    public deliverySubZones: any[] = [];
    public selectedZoneParent: string = '';
    public zoneForm: any = {};
    public zoneEditing: boolean = false;

    // 여행사관리
    public travelAgencies: any[] = [];
    public travelAgencySearch: string = '';
    public travelAgencyForm: any = {};
    public travelAgencyEditing: boolean = false;

    // 기사관리
    public travelDrivers: any[] = [];
    public travelDriverForm: any = {};
    public travelDriverEditing: boolean = false;

    // 여행사 예약관리
    public travelReservations: any[] = [];
    public travelResTotal: number = 0;
    public travelResPage: number = 1;
    public travelResDate: string = '';
    public travelResAgency: string = '';
    public travelResForm: any = {};
    public travelResEditing: boolean = false;
    public travelResItems: any[] = [];
    public travelResItemForm: any = {};

    // 포스출력물관리
    public printTemplates: any[] = [
        { name: '영수증', desc: '거래 영수증 출력 양식', enabled: true },
        { name: '주방주문서', desc: '주방 출력 양식', enabled: true },
        { name: '대기표', desc: '대기번호 출력 양식', enabled: false },
        { name: '간이영수증', desc: '간이 영수증 출력 양식', enabled: false }
    ];

    // 바코드출력환경
    public bcEnvSamples: any[] = [];
    public bcEnvActuals: any[] = [];
    public bcEnvSelectedId: string = '';
    public bcEnvForm: any = null;
    public bcEnvPrintQty: number = 1;
    public bcEnvPrtDat: any[] = Array.from({ length: 5 }, () => ({ f: '', a: '0', prefix: '', suffix: '', x: 0, y: 0, w: 1, h: 0, r: '0', b: '0', t: '' }));

    // 바코드출력
    public barcodeProducts: any[] = [];
    public bcPrintSearch: any = { price_date: '', is_sale: '', prod_cd: '', prod_nm: '', bar_cd: '', page_size: 100 };
    public bcPrintQty: number = 1;
    public bcPriceType: string = 'sale';
    public bcPrintEnvId: string = '';
    public bcPrintAllChecked: boolean = false;

    // 매장정보관리 (확장)
    public storeTimeSlots: any[] = [
        { selected: false, name: '심야', startTime: '0', endTime: '6' },
        { selected: false, name: '아침', startTime: '6', endTime: '11' },
        { selected: false, name: '점심', startTime: '11', endTime: '16' },
        { selected: false, name: '저녁', startTime: '16', endTime: '24' }
    ];
    public storeTimeSelectAll: boolean = false;
    public storeCustomerTypes: any = { type1: '남자', type2: '여자', type3: '', type4: '' };

    // 사원정보관리 (확장)
    public empSearchNo: string = '';
    public empSearchName: string = '';
    public empSearchId: string = '';
    public empSearchStatus: string = '';

    // 사원정보조회
    public empInqDateType: string = '미사용';
    public empInqDateFrom: string = '';
    public empInqDateTo: string = '';
    public empInqSearchType: string = '사원번호';
    public empInqSearchValue: string = '';
    public empInqPhone: string = '';
    public empInqMobile: string = '';
    public empInqRowCount: number = 20;
    public empInqEmpType: string = '';
    public empInqPosition: string = '';
    public empInqRetireStatus: string = '';
    public empInqWebUse: string = '';
    public empInqSmsRecv: string = '';
    public empInqResults: any[] = [];

    // 패스워드변경 (확장)
    public pwCurrentError: string = '';
    public pwNewError: string = '';
    public pwConfirmError: string = '';

    // 포스기능정의
    public posFuncTab: string = 'usage';
    public posFuncSelectedGroup: string = '';
    public posFuncAuthSelectedGroup: string = '';
    public posFuncGroups: any[] = [
        { name: '영업관리', funcCount: 16, regCount: 14 },
        { name: '테이블-일반', funcCount: 29, regCount: 11 },
        { name: '테이블-배달', funcCount: 12, regCount: 10 },
        { name: '주문취소관리', funcCount: 5, regCount: 5 },
        { name: '영수증관리', funcCount: 5, regCount: 4 },
        { name: '일반-판매처리', funcCount: 79, regCount: 18 },
        { name: '매출현황', funcCount: 12, regCount: 12 },
        { name: '환경설정', funcCount: 12, regCount: 11 },
        { name: '결제메뉴', funcCount: 35, regCount: 7 },
        { name: '복합결제', funcCount: 14, regCount: 4 },
        { name: '출력관리', funcCount: 5, regCount: 5 }
    ];
    public posFuncAuthGroups: string[] = ['영업관리','테이블-일반','테이블-포장','테이블-배달','주문취소관리','영수증관리','일반-판매처리','매출현황','수발주관리','환경설정','결제메뉴','복합결제','출력관리','공통코드'];
    private posFuncDataMap: any = {
        '영업관리': [[101,'공지사항'],[103,'마감취소'],[109,'마감정산'],[112,'중간정산'],[113,'준비금등록'],[104,'시재입출금'],[104,'시재점검'],[106,'외상입금'],[107,'사원근태'],[108,'판매원변경'],[110,'상품권판매'],[114,'기사출금'],[115,'매출I/F'],[117,'전자상품권'],[119,'선불카드'],[121,'한국선불카드']],
        '테이블-일반': [[1,'이동'],[3,'단체'],[7,'영수증 관리'],[12,'주문서 조회'],[18,'직전영수증'],[8,'재출력'],[11,'판매현황'],[5,'대기접수'],[4,'예약관리'],[6,'웹정보'],[9,'환전'],[2,'분할'],[10,'간이 영수증'],[13,'10GaZi'],[14,'SALT'],[15,'영수증쿠폰'],[16,'근태관리'],[17,'웹사이트접속'],[19,'모바일오더'],[22,'배달'],[24,'배달현황'],[25,'YESIR'],[28,'시재입출금'],[29,'직전카드전표'],[30,'매출요약'],[31,'A.POS 호출'],[32,'호출'],[34,'테이블QR 발급'],[35,'Npay 키오스크']],
        '테이블-배달': [[62,'배달현황'],[61,'배달처리'],[63,'입금처리'],[64,'그릇회수'],[70,'전화번호목록'],[65,'판매현황'],[66,'환전'],[67,'영수증관리'],[69,'입출금현황'],[73,'배달대행현황'],[68,'웹정보'],[72,'웹사이트접속']],
        '주문취소관리': [[226,'전체취소'],[248,'할인'],[227,'선택취소'],[228,'수량감소'],[229,'수량변경']],
        '영수증관리': [[233,'반품'],[263,'재출력'],[261,'회원적립'],[234,'결제변경'],[262,'OK캐쉬백']],
        '일반-판매처리': [[211,'환전'],[215,'초장'],[251,'전체포장'],[216,'회원등록'],[212,'확장메뉴'],[245,'회원검색'],[241,'결제추가'],[201,'상품조회'],[207,'수표조회'],[209,'출력관리'],[217,'단가변경'],[221,'예약조회'],[224,'중간계산서'],[239,'외상결제'],[252,'입금/출금'],[208,'대기'],[272,'직전영수증'],[293,'직전카드전표'],[202,'매출요약'],[203,'재고조회'],[204,'타매장재고'],[206,'배달처리'],[210,'웹정보'],[213,'주문접수'],[220,'여행사조회'],[222,'발권(수량)'],[223,'배달전문접수'],[225,'로열티 쿠폰'],[230,'퇴실'],[231,'보관함출력'],[232,'다음단골'],[235,'입장(바코드)'],[236,'퇴장(바코드)'],[238,'TRS'],[240,'주차권'],[241,'예술의전당'],[242,'1mile'],[243,'NH비타민'],[244,'계열사할인'],[246,'재고폐기'],[247,'기부'],[249,'칸투칸쿠폰'],[250,'칸투칸 AS'],[253,'판매현황'],[254,'SALT'],[255,'PAYCO'],[257,'입장/퇴장 내역'],[258,'교환'],[259,'영수증 쿠폰'],[260,'SURF'],[265,'객층관리'],[266,'주방메모'],[267,'대기표발급'],[268,'온라인발권'],[269,'레저큐'],[270,'웹사이트접속'],[276,'모바일오더'],[277,'판매종료'],[278,'스마트폰 문자'],[279,'배달접수'],[280,'배달주문내역'],[281,'배달현황'],[282,'A.POS 호출'],[284,'무료주차적립'],[287,'품절'],[288,'코코넛 적립'],[289,'YESIR'],[295,'고고박스호출'],[296,'샐러디'],[298,'컵회수'],[299,'e코오롱'],[320,'상품터치키 품절'],[702,'호출(알림톡)'],[704,'픽업호출'],[705,'테이블QR 발급'],[706,'QR오더 바로가기'],[708,'Npay 키오스크'],[709,'NAVER 리뷰 QR 출력'],[710,'크럭스적립']],
        '매출현황': [[301,'분류별매출현황'],[302,'상품별매출현황'],[303,'결제유형별매출현황'],[304,'할인유형별매출현황'],[305,'월별매출현황'],[306,'정산현황'],[307,'시간대별매출현황'],[308,'영수증별매출현황'],[309,'상품별주문취소현황'],[310,'코너별매출현황'],[311,'시재입출금 현황'],[312,'테이블그룹별매출현황']],
        '환경설정': [[502,'포스별환경설정'],[506,'매출자료수신'],[511,'보안리더기무결성점검'],[504,'마스터수신설정'],[503,'자료보관(백업)'],[505,'단말기인증'],[507,'원격제어'],[508,'시스템로그전송'],[509,'포스데이터관리'],[510,'매출자료전송'],[512,'KT CID 설정'],[514,'네이버커넥트 연동']],
        '복합결제': [[802,'신용카드'],[801,'현금'],[807,'회원포인트'],[811,'기타결제'],[809,'사원카드'],[803,'제휴선할인카드'],[804,'상품권'],[805,'식권'],[806,'외상'],[808,'제휴사용'],[810,'모바일쿠폰'],[813,'간편결제'],[814,'통신사할인'],[817,'기타']],
        '출력관리': [[901,'영수증출력'],[902,'고객주문서'],[903,'주방주문서'],[904,'간이 영수증'],[906,'중간계산서']]
    };

    // 포스출력물관리 (POS Template Editor)
    public prtClsCd: string = '01';
    public prtClsOptions: any[] = [
        {code:'01',label:'일반영수증'},{code:'02',label:'신용카드-가맹점용'},{code:'03',label:'고객주문서'},{code:'04',label:'주방주문서'},
        {code:'05',label:'중간계산서'},{code:'06',label:'푸드교환권'},{code:'07',label:'테이블이동'},{code:'08',label:'중간정산서'},
        {code:'09',label:'마감정산서'},{code:'10',label:'간이영수증'},{code:'11',label:'신용전표-회수용'},{code:'12',label:'신용전표-보관용'},
        {code:'13',label:'시재점검'},{code:'14',label:'배달영수증-고객용'},{code:'15',label:'배달전표-배달원용'},{code:'16',label:'포장교환권'},
        {code:'17',label:'유니온페이MPM QR (개발중)'},{code:'18',label:'고객주문서-NAVER 전용'},{code:'19',label:'주방주문서-NAVER 전용'},
        {code:'21',label:'비매출-현금영수증-회수용'},{code:'22',label:'비매출-상품권판매'},{code:'23',label:'비매출-식권판매'},
        {code:'24',label:'비매출-외상입금'},{code:'25',label:'비매출-제휴포인트카드'},
        {code:'31',label:'매출현황-분류별'},{code:'32',label:'매출현황-상품별'},{code:'33',label:'매출현황-결제수단별'},
        {code:'34',label:'매출현황-할인항목별'},{code:'35',label:'매출현황-월별'},{code:'36',label:'시재입출금'},
        {code:'37',label:'기간별정산내역'},{code:'38',label:'매출현황-시간대별'},{code:'39',label:'비매출-현금영수증-보관용'},
        {code:'40',label:'매출현황-영수증별'},{code:'41',label:'이용권'},{code:'42',label:'기사수수료'},
        {code:'43',label:'매출현황-상품별취소'},{code:'44',label:'테스트용'},{code:'45',label:'매출현황-코너별'},
        {code:'46',label:'매출현황-시재입출금현황'},{code:'48',label:'대기표'},{code:'49',label:'단골플러스 영수증쿠폰'},
        {code:'50',label:'입장권'},{code:'51',label:'현금영수증-보관용'},{code:'53',label:'주방재출력'},
        {code:'54',label:'매출현황-테이블그룹별'},{code:'56',label:'분할결제영수증-NICE 전용'},
        {code:'58',label:'배달영수증-고객용(배달매니저)'},{code:'59',label:'배달전표-배달원용(배달매니저)'},
        {code:'60',label:'포장전표-고객용(배달매니저)'},{code:'61',label:'KIOSK_일반영수증'},{code:'62',label:'KIOSK_교환권'},
        {code:'63',label:'테이블QR'},{code:'64',label:'주방주문서-상하반전'},{code:'65',label:'테이블이동-상하반전'},
        {code:'66',label:'주방재출력-상하반전'},{code:'67',label:'네이버 영수증 리뷰 QR코드'},{code:'70',label:'코보시스 QR코드 교환권'}
    ];
    public prtTemplates: string[] = [];
    public prtSelectedTemplateIdx: number = -1;
    public prtCodeList: string[] = [];
    public prtEditContent: string = '';
    public prtViewerContent: string = '';

    public categories: any = {
        'store': {
            label: '매장관리',
            items: ['매장정보관리', '사원정보관리', '사원정보조회', '패스워드변경', 'VAN/코너 정보', '테이블속성', '테이블관리', '포스기능정의']
        },
        'print': {
            label: '출력물관리',
            items: ['포스출력물관리', '포스출력물로그', '바코드출력환경', '바코드출력']
        },
        'product': {
            label: '상품관리',
            items: ['상품기초정보등록', '거래처등록', '거래처엑셀업로드', '거래처조회', '상품등록', '상품조회', '상품엑셀업로드', '간편상품등록', '상품정보일괄변경', '상품바코드등록', '사이드메뉴등록', '판매터치키등록', '주방프린터-상품연결', '주방프린터-시간대제어']
        },
        'price': {
            label: '가격관리',
            items: ['판매가관리', '매장판매가 History', '판매가현황', '원가임의변경', '원가변경 History']
        },
        'payment': {
            label: '결제수단',
            items: ['제휴카드등록', '상품권등록', '식권등록', '쿠폰등록', '고정할인등록']
        },
        'etc': {
            label: '기타관리',
            items: ['명칭관리', '예약관리(웹전용)', '주방메모관리', '배달구역관리']
        },
        'kiosk': {
            label: '키오스크관리',
            items: ['키오스크 이미지관리', '다국어 관리', '키오스크터치키관리', '품절일괄변경']
        },
        'kiosk2': {
            label: '키오스크관리(2.0전용)',
            items: ['할인/판매 시간관리', '키오스크 터치키 관리']
        },
        'qrorder': {
            label: 'QR오더 & 페이관리',
            items: ['QR오더 터치키 관리']
        },
        'kiosknaver': {
            label: '키오스크관리(Naver)',
            items: ['키오스크 관리']
        }
    };

    // 결제수단 서브 메뉴 → method_type 매핑
    private paymentTypeMap: any = {
        '제휴카드등록': 'card',
        '상품권등록': 'voucher',
        '식권등록': 'meal_ticket',
        '쿠폰등록': 'coupon'
    };

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.updateRoute();
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                await this.updateRoute();
                await this.service.render();
            }
        });
        await this.service.render();
    }

    ngOnDestroy() { if (this.routerSub) this.routerSub.unsubscribe(); }

    private async updateRoute() {
        const seg = WizRoute.segment;
        this.category = seg.category || 'store';
        try {
            this.sub = seg.sub ? decodeURIComponent(seg.sub) : '';
        } catch {
            this.sub = seg.sub || '';
        }
        if (!seg.category) {
            this.service.href('/basic/store');
            return;
        }
        if (this.sub) {
            await this.loadSubData();
        }
    }

    public categoryKeys(): string[] { return Object.keys(this.categories); }
    public isActiveCat(key: string): boolean { return this.category === key; }

    public async selectSub(item: string) {
        this.service.href(`/basic/${this.category}/${encodeURIComponent(item)}`);
    }

    private async loadSubData() {
        if (this.sub === '매장정보관리') await this.loadStore();
        if (this.sub === '사원정보관리') await this.loadEmployees();
        if (this.sub === '사원정보조회') await this.loadEmployeeInquiry();
        if (this.sub === '패스워드변경') this.initPasswordForm();
        if (this.sub === '포스기능정의') this.initPosFunc();
        if (this.sub === '상품기초정보등록') { await this.loadCategories(); await this.loadBrands(); }
        if (this.sub === '거래처등록' || this.sub === '거래처조회') await this.loadSuppliers();
        if (this.sub === '상품등록' || this.sub === '상품조회') await this.loadProducts();
        if (this.sub === '판매가관리' || this.sub === '판매가현황' || this.sub === '원가임의변경') await this.loadPriceList();
        if (this.paymentTypeMap[this.sub]) {
            this.activePaymentType = this.paymentTypeMap[this.sub];
            await this.loadPayments();
        }
        if (this.sub === '명칭관리') await this.loadCodeGroups();
        if (this.sub === '예약관리(웹전용)') await this.loadReservations();
        if (this.sub === '주방메모관리') await this.loadKitchenMemos();
        if (this.sub === '배달구역관리') await this.loadDeliveryZones();
        if (this.sub === '여행사관리') await this.loadTravelAgencies();
        if (this.sub === '기사관리') await this.loadTravelDrivers();
        if (this.sub === '여행사 예약관리') { await this.loadTravelReservations(); await this.loadTravelAgencies(); }
        if (this.sub === '포스출력물관리') await this.loadPrintTemplateData();
        if (this.sub === '바코드출력환경') await this.loadBarcodeEnvData();
        if (this.sub === '바코드출력') { await this.loadBarcodeEnvData(); this.barcodeProducts = []; }
    }

    // ===== 매장정보 =====
    public async loadStore() {
        let res = await wiz.call("store_info");
        if (res.code === 200 && res.data?.data) this.storeData = res.data.data;
        else this.storeData = { name: '', zipcode: '', address: '', address_detail: '', phone: '', biz_hours_start: '09:00', biz_hours_end: '22:00' };
    }

    public async saveStore() {
        let res = await wiz.call("store_save", this.storeData);
        if (res.code === 200) await this.service.modal.show({ title: '', message: '저장되었습니다.', cancel: false, action: '확인', status: 'success' });
        else await this.service.modal.show({ title: '', message: res.data?.message || '저장 실패', cancel: false, action: '확인', status: 'error' });
    }

    // ===== 사원관리 =====
    public async loadEmployees() {
        let res = await wiz.call("employee_list", { text: this.empSearch, page: this.empPage });
        if (res.code === 200) { this.employees = res.data?.data || []; this.empTotal = res.data?.total || 0; }
    }

    public async newEmployee() {
        this.empForm = { emp_no: '', name: '', position: '', phone: '', address: '', employment_status: 'active', hourly_wage: 0 };
        this.empEditing = true;
        await this.service.render();
    }

    public async editEmployee(emp: any) {
        this.empForm = JSON.parse(JSON.stringify(emp));
        this.empEditing = true;
        await this.service.render();
    }

    public async saveEmployee() {
        let res = await wiz.call("employee_save", this.empForm);
        if (res.code === 200) {
            this.empEditing = false;
            await this.loadEmployees();
            await this.service.render();
        } else {
            await this.service.modal.show({ title: '', message: res.data?.message || '저장 실패', cancel: false, action: '확인', status: 'error' });
        }
    }

    public async deleteEmployee(id: string) {
        let confirm = await this.service.modal.show({ title: '', message: '삭제하시겠습니까?', action: '삭제', status: 'error' });
        if (!confirm) return;
        let res = await wiz.call("employee_delete", { id });
        if (res.code === 200) { await this.loadEmployees(); await this.service.render(); }
    }

    // ===== 패스워드 =====
    public async changePassword() {
        if (this.pwForm.newpw !== this.pwForm.confirm) {
            await this.service.modal.show({ title: '', message: '신규 비밀번호가 일치하지 않습니다.', cancel: false, action: '확인', status: 'error' });
            return;
        }
        if (this.pwForm.newpw.length < 6 || this.pwForm.newpw.length > 10) {
            await this.service.modal.show({ title: '', message: '비밀번호는 6~10자여야 합니다.', cancel: false, action: '확인', status: 'error' });
            return;
        }
        let res = await wiz.call("change_password", { current: this.pwForm.current, newpw: this.pwForm.newpw });
        if (res.code === 200) {
            this.pwForm = { current: '', newpw: '', confirm: '' };
            await this.service.modal.show({ title: '', message: '비밀번호가 변경되었습니다.', cancel: false, action: '확인', status: 'success' });
        } else {
            await this.service.modal.show({ title: '', message: res.data?.message || '변경 실패', cancel: false, action: '확인', status: 'error' });
        }
        await this.service.render();
    }

    // ===== 상품분류 =====
    public async loadCategories() {
        let res = await wiz.call("category_list", { level: 1 });
        if (res.code === 200) this.catLevel1 = res.data?.data || [];
        this.catLevel2 = [];
        this.catLevel3 = [];
        this.selectedCat1 = '';
        this.selectedCat2 = '';
    }

    public async selectCat1(id: string) {
        this.selectedCat1 = id;
        let res = await wiz.call("category_list", { level: 2, parent_id: id });
        if (res.code === 200) this.catLevel2 = res.data?.data || [];
        this.catLevel3 = [];
        this.selectedCat2 = '';
        await this.service.render();
    }

    public async selectCat2(id: string) {
        this.selectedCat2 = id;
        let res = await wiz.call("category_list", { level: 3, parent_id: id });
        if (res.code === 200) this.catLevel3 = res.data?.data || [];
        await this.service.render();
    }

    public async saveCategory(level: number, parentId: string = '') {
        this.catForm.level = level;
        if (parentId) this.catForm.parent_id = parentId;
        let res = await wiz.call("category_save", this.catForm);
        if (res.code === 200) {
            this.catForm = {};
            await this.loadCategories();
            await this.service.render();
        }
    }

    public async deleteCategory(id: string) {
        let confirm = await this.service.modal.show({ title: '', message: '삭제하시겠습니까?', action: '삭제', status: 'error' });
        if (!confirm) return;
        let res = await wiz.call("category_delete", { id });
        if (res.code !== 200) {
            await this.service.modal.show({ title: '', message: res.data?.message || '삭제 실패', cancel: false, action: '확인', status: 'error' });
        }
        await this.loadCategories();
        await this.service.render();
    }

    // ===== 브랜드 =====
    public async loadBrands() {
        let res = await wiz.call("brand_list");
        if (res.code === 200) this.brands = res.data?.data || [];
    }

    public async saveBrand() {
        let res = await wiz.call("brand_save", this.brandForm);
        if (res.code === 200) { this.brandForm = {}; await this.loadBrands(); await this.service.render(); }
    }

    public async deleteBrand(id: string) {
        let confirm = await this.service.modal.show({ title: '', message: '삭제하시겠습니까?', action: '삭제', status: 'error' });
        if (!confirm) return;
        let res = await wiz.call("brand_delete", { id });
        if (res.code !== 200) await this.service.modal.show({ title: '', message: res.data?.message || '삭제 실패', cancel: false, action: '확인', status: 'error' });
        await this.loadBrands();
        await this.service.render();
    }

    // ===== 거래처 =====
    public async loadSuppliers() {
        let res = await wiz.call("supplier_list", { text: this.supplierSearch, page: this.supplierPage });
        if (res.code === 200) { this.suppliers = res.data?.data || []; this.supplierTotal = res.data?.total || 0; }
    }

    public async newSupplier() {
        this.supplierForm = { code: '', name: '', supplier_type: '', contact: '', phone: '', address: '', biz_no: '' };
        this.supplierEditing = true;
        await this.service.render();
    }

    public editSupplier(s: any) {
        this.supplierForm = JSON.parse(JSON.stringify(s));
        this.supplierEditing = true;
        this.service.render();
    }

    public async saveSupplier() {
        let res = await wiz.call("supplier_save", this.supplierForm);
        if (res.code === 200) { this.supplierEditing = false; await this.loadSuppliers(); await this.service.render(); }
        else await this.service.modal.show({ title: '', message: res.data?.message || '저장 실패', cancel: false, action: '확인', status: 'error' });
    }

    public async deleteSupplier(id: string) {
        let confirm = await this.service.modal.show({ title: '', message: '삭제하시겠습니까?', action: '삭제', status: 'error' });
        if (!confirm) return;
        await wiz.call("supplier_delete", { id });
        await this.loadSuppliers();
        await this.service.render();
    }

    // ===== 상품 =====
    public async loadProducts() {
        let res = await wiz.call("product_list", { text: this.productSearch, page: this.productPage });
        if (res.code === 200) { this.products = res.data?.data || []; this.productTotal = res.data?.total || 0; }
    }

    public async newProduct() {
        this.productForm = { code: '', name: '', category_id: '', brand_id: '', supplier_id: '', barcode: '', origin: '', sell_price: 0, cost_price: 0, tax_type: 'tax', is_sale: 'Y', stock_manage: 'Y', safe_stock: 0 };
        this.productEditing = true;
        await this.service.render();
    }

    public editProduct(p: any) {
        this.productForm = JSON.parse(JSON.stringify(p));
        this.productEditing = true;
        this.service.render();
    }

    public async saveProduct() {
        let res = await wiz.call("product_save", this.productForm);
        if (res.code === 200) { this.productEditing = false; await this.loadProducts(); await this.service.render(); }
        else await this.service.modal.show({ title: '', message: res.data?.message || '저장 실패', cancel: false, action: '확인', status: 'error' });
    }

    public async deleteProduct(id: string) {
        let confirm = await this.service.modal.show({ title: '', message: '삭제하시겠습니까?', action: '삭제', status: 'error' });
        if (!confirm) return;
        await wiz.call("product_delete", { id });
        await this.loadProducts();
        await this.service.render();
    }

    // ===== 판매가관리 =====
    public async loadPriceList() {
        let res = await wiz.call("price_list", { text: this.priceSearch, page: this.pricePage });
        if (res.code === 200) {
            this.priceProducts = res.data?.data || [];
            this.priceTotal = res.data?.total || 0;
        }
        await this.service.render();
    }

    public async startPriceEdit(p: any) {
        this.priceEditingId = p.id;
        this.priceEditValue = p.sell_price || 0;
        await this.service.render();
    }

    public async cancelPriceEdit() {
        this.priceEditingId = '';
        await this.service.render();
    }

    public async savePriceEdit(p: any) {
        let params: any = { id: p.id };
        if (this.sub === '원가임의변경') {
            params.cost_price = this.priceEditValue;
        } else {
            params.sell_price = this.priceEditValue;
        }
        let res = await wiz.call("price_update", params);
        if (res.code === 200) {
            this.priceEditingId = '';
            await this.loadPriceList();
        } else {
            await this.service.modal.show({ title: '', message: res.data?.message || '변경 실패', cancel: false, action: '확인', status: 'error' });
        }
        await this.service.render();
    }

    // ===== 결제수단 =====
    public async loadPayments() {
        let res = await wiz.call("payment_list", { method_type: this.activePaymentType });
        if (res.code === 200) this.payments = res.data?.data || [];
        await this.service.render();
    }

    public paymentTypeLabel(): string {
        const map: any = { card: '제휴카드', voucher: '상품권', meal_ticket: '식권', coupon: '쿠폰' };
        return map[this.activePaymentType] || '';
    }

    public async newPayment() {
        this.paymentForm = { code: '', name: '', method_type: this.activePaymentType, discount_type: 'none', discount_value: 0, is_active: 'Y', description: '' };
        this.paymentEditing = true;
        await this.service.render();
    }

    public async editPayment(item: any) {
        this.paymentForm = JSON.parse(JSON.stringify(item));
        this.paymentEditing = true;
        await this.service.render();
    }

    public async savePayment() {
        let res = await wiz.call("payment_save", this.paymentForm);
        if (res.code === 200) {
            this.paymentEditing = false;
            await this.loadPayments();
        } else {
            await this.service.modal.show({ title: '', message: res.data?.message || '저장 실패', cancel: false, action: '확인', status: 'error' });
        }
        await this.service.render();
    }

    public async deletePayment(id: string) {
        let confirm = await this.service.modal.show({ title: '', message: '삭제하시겠습니까?', action: '삭제', status: 'error' });
        if (!confirm) return;
        await wiz.call("payment_delete", { id });
        await this.loadPayments();
        await this.service.render();
    }

    public async cancelPaymentEdit() {
        this.paymentEditing = false;
        await this.service.render();
    }

    // ===== 명칭관리 =====
    public async loadCodeGroups() {
        let res = await wiz.call("code_group_list");
        if (res.code === 200) this.codeGroups = res.data?.data || [];
        this.codeItems = [];
        this.selectedCodeGroup = '';
        await this.service.render();
    }

    public async selectCodeGroup(groupCode: string) {
        this.selectedCodeGroup = groupCode;
        let res = await wiz.call("code_item_list", { group_code: groupCode });
        if (res.code === 200) this.codeItems = res.data?.data || [];
        this.codeEditing = false;
        await this.service.render();
    }

    public async newCode() {
        this.codeForm = { group_code: this.selectedCodeGroup || '', group_name: '', code: '', name: '', sort_order: 0, is_active: 'Y' };
        this.codeEditing = true;
        await this.service.render();
    }

    public async editCode(item: any) {
        this.codeForm = JSON.parse(JSON.stringify(item));
        this.codeEditing = true;
        await this.service.render();
    }

    public async saveCode() {
        let res = await wiz.call("code_save", this.codeForm);
        if (res.code === 200) {
            this.codeEditing = false;
            await this.loadCodeGroups();
            if (this.selectedCodeGroup) await this.selectCodeGroup(this.selectedCodeGroup);
        } else {
            await this.service.modal.show({ title: '', message: res.data?.message || '저장 실패', cancel: false, action: '확인', status: 'error' });
        }
    }

    public async deleteCode(id: string) {
        let confirm = await this.service.modal.show({ title: '', message: '삭제하시겠습니까?', action: '삭제', status: 'error' });
        if (!confirm) return;
        await wiz.call("code_delete", { id });
        await this.loadCodeGroups();
        if (this.selectedCodeGroup) await this.selectCodeGroup(this.selectedCodeGroup);
    }

    // ===== 예약관리 =====
    public async loadReservations() {
        let res = await wiz.call("reservation_list", { date: this.reservationDate, status: this.reservationStatus, page: this.reservationPage });
        if (res.code === 200) { this.reservations = res.data?.data || []; this.reservationTotal = res.data?.total || 0; }
        await this.service.render();
    }

    public async newReservation() {
        this.reservationForm = { reservation_date: '', reservation_time: '', customer_name: '', phone: '', party_size: 1, table_no: '', status: 'confirmed', memo: '' };
        this.reservationEditing = true;
        await this.service.render();
    }

    public async editReservation(item: any) {
        this.reservationForm = JSON.parse(JSON.stringify(item));
        this.reservationEditing = true;
        await this.service.render();
    }

    public async saveReservation() {
        let res = await wiz.call("reservation_save", this.reservationForm);
        if (res.code === 200) { this.reservationEditing = false; await this.loadReservations(); }
        else await this.service.modal.show({ title: '', message: res.data?.message || '저장 실패', cancel: false, action: '확인', status: 'error' });
    }

    public async deleteReservation(id: string) {
        let confirm = await this.service.modal.show({ title: '', message: '삭제하시겠습니까?', action: '삭제', status: 'error' });
        if (!confirm) return;
        await wiz.call("reservation_delete", { id });
        await this.loadReservations();
    }

    // ===== 주방메모관리 =====
    public async loadKitchenMemos() {
        let res = await wiz.call("kitchen_memo_list");
        if (res.code === 200) this.kitchenMemos = res.data?.data || [];
        await this.service.render();
    }

    public async newKitchenMemo() {
        this.kitchenMemoForm = { code: '', content: '', sort_order: 0, is_active: 'Y' };
        this.kitchenMemoEditing = true;
        await this.service.render();
    }

    public async editKitchenMemo(item: any) {
        this.kitchenMemoForm = JSON.parse(JSON.stringify(item));
        this.kitchenMemoEditing = true;
        await this.service.render();
    }

    public async saveKitchenMemo() {
        let res = await wiz.call("kitchen_memo_save", this.kitchenMemoForm);
        if (res.code === 200) { this.kitchenMemoEditing = false; await this.loadKitchenMemos(); }
        else await this.service.modal.show({ title: '', message: res.data?.message || '저장 실패', cancel: false, action: '확인', status: 'error' });
    }

    public async deleteKitchenMemo(id: string) {
        let confirm = await this.service.modal.show({ title: '', message: '삭제하시겠습니까?', action: '삭제', status: 'error' });
        if (!confirm) return;
        await wiz.call("kitchen_memo_delete", { id });
        await this.loadKitchenMemos();
    }

    // ===== 배달구역관리 =====
    public async loadDeliveryZones() {
        let res = await wiz.call("delivery_zone_list", { parent_id: '' });
        if (res.code === 200) this.deliveryZones = res.data?.data || [];
        this.deliverySubZones = [];
        this.selectedZoneParent = '';
        await this.service.render();
    }

    public async selectZoneParent(id: string) {
        this.selectedZoneParent = id;
        let res = await wiz.call("delivery_zone_list", { parent_id: id });
        if (res.code === 200) this.deliverySubZones = res.data?.data || [];
        await this.service.render();
    }

    public async newZone(parentId: string = '') {
        this.zoneForm = { name: '', parent_id: parentId, sort_order: 0, delivery_fee: 0, is_active: 'Y' };
        this.zoneEditing = true;
        await this.service.render();
    }

    public async editZone(item: any) {
        this.zoneForm = JSON.parse(JSON.stringify(item));
        this.zoneEditing = true;
        await this.service.render();
    }

    public async saveZone() {
        let res = await wiz.call("delivery_zone_save", this.zoneForm);
        if (res.code === 200) {
            this.zoneEditing = false;
            await this.loadDeliveryZones();
            if (this.selectedZoneParent) await this.selectZoneParent(this.selectedZoneParent);
        } else {
            await this.service.modal.show({ title: '', message: res.data?.message || '저장 실패', cancel: false, action: '확인', status: 'error' });
        }
    }

    public async deleteZone(id: string) {
        let confirm = await this.service.modal.show({ title: '', message: '삭제하시겠습니까?', action: '삭제', status: 'error' });
        if (!confirm) return;
        await wiz.call("delivery_zone_delete", { id });
        await this.loadDeliveryZones();
        if (this.selectedZoneParent) await this.selectZoneParent(this.selectedZoneParent);
    }

    // ===== 여행사관리 =====
    public async loadTravelAgencies() {
        let res = await wiz.call("travel_agency_list", { text: this.travelAgencySearch });
        if (res.code === 200) this.travelAgencies = res.data?.data || [];
        await this.service.render();
    }

    public async newTravelAgency() {
        this.travelAgencyForm = { name: '', ceo_name: '', biz_no: '', phone: '', fax: '', address: '', commission_rate: 0, contract_start: '', contract_end: '', memo: '', is_active: 'Y' };
        this.travelAgencyEditing = true;
        await this.service.render();
    }

    public async editTravelAgency(item: any) {
        this.travelAgencyForm = JSON.parse(JSON.stringify(item));
        this.travelAgencyEditing = true;
        await this.service.render();
    }

    public async saveTravelAgency() {
        let res = await wiz.call("travel_agency_save", this.travelAgencyForm);
        if (res.code === 200) { this.travelAgencyEditing = false; await this.loadTravelAgencies(); }
        else await this.service.modal.show({ title: '', message: res.data?.message || '저장 실패', cancel: false, action: '확인', status: 'error' });
    }

    public async deleteTravelAgency(id: string) {
        let confirm = await this.service.modal.show({ title: '', message: '삭제하시겠습니까?', action: '삭제', status: 'error' });
        if (!confirm) return;
        await wiz.call("travel_agency_delete", { id });
        await this.loadTravelAgencies();
    }

    // ===== 기사관리 =====
    public async loadTravelDrivers() {
        let res = await wiz.call("travel_driver_list");
        if (res.code === 200) this.travelDrivers = res.data?.data || [];
        await this.service.render();
    }

    public async newTravelDriver() {
        this.travelDriverForm = { name: '', phone: '', vehicle_no: '', license_no: '', agency_id: '', commission_rate: 0, is_active: 'Y' };
        this.travelDriverEditing = true;
        await this.service.render();
    }

    public async editTravelDriver(item: any) {
        this.travelDriverForm = JSON.parse(JSON.stringify(item));
        this.travelDriverEditing = true;
        await this.service.render();
    }

    public async saveTravelDriver() {
        let res = await wiz.call("travel_driver_save", this.travelDriverForm);
        if (res.code === 200) { this.travelDriverEditing = false; await this.loadTravelDrivers(); }
        else await this.service.modal.show({ title: '', message: res.data?.message || '저장 실패', cancel: false, action: '확인', status: 'error' });
    }

    public async deleteTravelDriver(id: string) {
        let confirm = await this.service.modal.show({ title: '', message: '삭제하시겠습니까?', action: '삭제', status: 'error' });
        if (!confirm) return;
        await wiz.call("travel_driver_delete", { id });
        await this.loadTravelDrivers();
    }

    // ===== 여행사 예약관리 =====
    public async loadTravelReservations() {
        let res = await wiz.call("travel_reservation_list", { date: this.travelResDate, agency_id: this.travelResAgency, page: this.travelResPage });
        if (res.code === 200) { this.travelReservations = res.data?.data || []; this.travelResTotal = res.data?.total || 0; }
        await this.service.render();
    }

    public async newTravelReservation() {
        this.travelResForm = { agency_id: '', driver_id: '', reservation_date: '', arrival_time: '', departure_time: '', group_name: '', pax: 1, total_amount: 0, status: 'confirmed', memo: '' };
        this.travelResEditing = true;
        this.travelResItems = [];
        await this.service.render();
    }

    public async editTravelReservation(item: any) {
        this.travelResForm = JSON.parse(JSON.stringify(item));
        this.travelResEditing = true;
        let res = await wiz.call("travel_reservation_items", { reservation_id: item.id });
        if (res.code === 200) this.travelResItems = res.data?.data || [];
        await this.service.render();
    }

    public async saveTravelReservation() {
        let res = await wiz.call("travel_reservation_save", this.travelResForm);
        if (res.code === 200) { this.travelResEditing = false; await this.loadTravelReservations(); }
        else await this.service.modal.show({ title: '', message: res.data?.message || '저장 실패', cancel: false, action: '확인', status: 'error' });
    }

    public async deleteTravelReservation(id: string) {
        let confirm = await this.service.modal.show({ title: '', message: '삭제하시겠습니까?', action: '삭제', status: 'error' });
        if (!confirm) return;
        await wiz.call("travel_reservation_delete", { id });
        await this.loadTravelReservations();
    }

    public getAgencyName(id: string): string {
        let a = this.travelAgencies.find((x: any) => x.id === id);
        return a ? a.name : '';
    }

    // ===== 포스출력물관리 (POS Template Editor) =====
    public async loadPrintTemplateData() {
        this.prtClsCd = '01';
        await this.clsChange();
    }

    public async clsChange() {
        const data = this.getPrtDataForType(this.prtClsCd);
        this.prtTemplates = data.templates;
        this.prtSelectedTemplateIdx = -1;
        this.prtCodeList = [];
        this.prtEditContent = '';
        this.prtViewerContent = '';
        await this.service.render();
    }

    public async selectPrtTemplate(idx: number) {
        this.prtSelectedTemplateIdx = idx;
        const data = this.getPrtDataForType(this.prtClsCd);
        const tplName = this.prtTemplates[idx];
        this.prtCodeList = data.codes || [];
        this.prtEditContent = (data.defaults && data.defaults[tplName]) || '';
        this.prtViewerContent = this.prtEditContent ? this.generatePrtViewer(this.prtEditContent) : '';
        await this.service.render();
    }

    public async insertPrtCode(code: string) {
        this.prtEditContent += code;
        await this.service.render();
    }

    public async updatePrtViewer() {
        this.prtViewerContent = this.generatePrtViewer(this.prtEditContent);
        await this.service.render();
    }

    public async savePrtTemplate() {
        if (this.prtSelectedTemplateIdx < 0) return;
        const tplName = this.prtTemplates[this.prtSelectedTemplateIdx];
        let res = await wiz.call('print_template_save', {
            cls_cd: this.prtClsCd,
            template_name: tplName,
            content: this.prtEditContent
        });
        if (res.code === 200) {
            await this.service.modal.show({ title: '', message: '저장되었습니다.', cancel: false, action: '확인', status: 'success' });
        } else {
            await this.service.modal.show({ title: '', message: res.data?.message || '저장 실패', cancel: false, action: '확인', status: 'error' });
        }
    }

    private getPrtDataForType(type: string): any {
        if (type === '01') {
            return {
                templates: ['실제출력물', '영수증-별도-신용전표', '영수증-일반', '영수증-절약(상품표기)', '영수증-절약전표'],
                codes: [
                    '{타이틀}','{LOG}','{상호}','{사업자}','{주소}','{대표자}','{전화번호}','{최초주문시간}','{매출시간}','{POSNO}','{계산원}',
                    '{상품리스트1}','{상품리스트2}','{상품리스트6}','{상품리스트8}','{상품리스트9}','{상품리스트10}','{상품리스트11}',
                    '{합계금액}','{할인금액}','{받을금액}','{세액}','{받은금액}','{신용카드}','{현금영수증}',
                    '{회원정보}','{회원정보2}','{회원정보3}','{회원주소}','{OKCASHBAG}','{BARCODE}','{CUT}','{SIGN}',
                    '{DATETIME}','{DATE}','{CRLF}','{영수증번호}','{결제리스트}','{회원정보코멘트}','{사업자명}','{재발행여부}',
                    '{:R10}오른쪽정렬{/:R}','{:C42}중앙정렬{/:C}','{:L10}왼쪽정렬{/:L}',
                    '{RIGHT}','{CENTER}','{LEFT}','{거스름}',
                    '{FONT1}','{FONT2}','{FONT3}','{FONT4}',
                    '{문자-확대취소}','{문자-세로확대}','{문자-가로확대}','{문자-가로세로확대}',
                    '{별도-신용승인전표-내역1}','{별도-신용승인전표-내역}','{별도-신용승인전표-타이틀}','{별도-신용승인전표-합계}',
                    '{테이블표기}','{서비스항목내역}','{EMP_OFF}','{EMP_ON}',
                    '{상품권정보1}','{상품권정보}','{여행사정보}','{예약정보}','{반품-원거래번호}',
                    '{배달테이블명}','{대기번호}','{주문번호}','{진동벨번호}','{손님수}',
                    '{별도-신용승인전표-합계1}',
                    '{FONTBIG0}','{FONTBIG1}','{FONTBIG2}','{FONTBIG3}','{FONTBIG4}','{FONTBIG5}','{FONTBIG6}','{FONTBIG7}',
                    '{모바일쿠폰}','{캐시비}','{즉시환급정보}','{단골플러스쿠폰}','{상품리스트-할인가}','{즉시환급수수료}',
                    '{선불카드}','{간편결제}','{전자상품권}','{BARCODE-주차권}','{교환번호}','{일회용품}',
                    '{:Q}QR메시지{/:Q}','{기타결제}','{상품리스트12}','{식권정보}'
                ],
                defaults: {
                    '영수증-일반': '{LOG}\n{:C42}{FONT2}{타이틀}{재발행여부}{FONT1}{/:C}{CRLF}\n[매장명] {상호}\n[사업자] {사업자}\n[주  소] {주소}\n[대표자] {대표자}     {:R20}[TEL] {전화번호}{/:R}\n[발행일] {매출시간}     {POSNO}-{계산원}\n[영수증] {영수증번호}\n==========================================\n{상품리스트1}\n------------------------------------------\n{합계금액}\n{할인금액}\n------------------------------------------\n{세액}\n------------------------------------------\n{받을금액}\n{받은금액}\n{거스름}\n------------------------------------------{결제리스트}\n------------------------------------------\n{현금영수증}\n{신용카드}\n{간편결제}\n{회원정보}\n{OKCASHBAG}\n\n* 물품반품시 본 영수증을 필히 지참하여\n  주시기 바랍니다. \n\n{BARCODE}\n{SIGN}\n\n{CUT}',
                    '실제출력물': '{LOG}\n{:C42}{FONT2}{타이틀}{재발행여부}{FONT1}{/:C}{CRLF}\n[매장명] {상호}\n[사업자] {사업자}\n[주  소] {주소}\n[대표자] {대표자}     {:R20}[TEL] {전화번호}{/:R}\n[발행일] {매출시간}     {POSNO}-{계산원}\n[영수증] {영수증번호}\n==========================================\n{상품리스트1}\n------------------------------------------\n{합계금액}\n{할인금액}\n------------------------------------------\n{세액}\n------------------------------------------\n{받을금액}\n{받은금액}\n{거스름}\n------------------------------------------{결제리스트}\n------------------------------------------\n{현금영수증}\n{신용카드}\n{간편결제}\n{회원정보}\n{OKCASHBAG}\n\n* 물품반품시 본 영수증을 필히 지참하여\n  주시기 바랍니다. \n\n{BARCODE}\n{CUT}\n\n{별도-신용승인전표-타이틀}\n{별도-신용승인전표-내역}\n{별도-신용승인전표-합계}\n\n{SIGN}\n\n발 행 정 보: {영수증번호}\n발 행 일 시: {DATETIME} {POSNO}-{계산원}\n\n{CUT}',
                    '영수증-별도-신용전표': '{LOG}\n{:C42}{FONT2}{타이틀}{재발행여부}{FONT1}{/:C}{CRLF}\n[매장명] {상호}\n[사업자] {사업자}\n[주  소] {주소}\n[대표자] {대표자}     {:R20}[TEL] {전화번호}{/:R}\n[발행일] {매출시간}     {POSNO}-{계산원}\n[영수증] {영수증번호}\n==========================================\n{상품리스트1}\n------------------------------------------\n{합계금액}\n{할인금액}\n------------------------------------------\n{세액}\n------------------------------------------\n{받을금액}\n{받은금액}\n{거스름}\n------------------------------------------{결제리스트}\n------------------------------------------\n{현금영수증}\n{신용카드}\n{간편결제}\n{회원정보}\n{OKCASHBAG}\n\n* 물품반품시 본 영수증을 필히 지참하여\n  주시기 바랍니다. \n\n{BARCODE}\n{CUT}\n\n{별도-신용승인전표-타이틀}\n{별도-신용승인전표-내역}\n{별도-신용승인전표-합계}\n\n{SIGN}\n\n발 행 정 보: {영수증번호}\n발 행 일 시: {DATETIME} {POSNO}-{계산원}\n\n{CUT}',
                    '영수증-절약(상품표기)': '{LOG}\n{:C42}{FONT1}{타이틀}{재발행여부}{FONT1}{/:C}{CRLF}\n{상호} / {사업자} / {대표자}\n{주소}\n{전화번호} / {영수증번호}\n{매출시간} \n------------------------------------------\n{상품리스트2}\n------------------------------------------\n{합계금액}\n{할인금액}\n------------------------------------------\n{세액}\n------------------------------------------\n{신용카드}\n{현금영수증}\n{간편결제}\n{회원정보}\n{OKCASHBAG}\n{상품권정보}\n{식권정보}\n{재출력}\n{CUT}',
                    '영수증-절약전표': '{LOG}\n{:C42}{FONT1}{타이틀}{재발행여부}{FONT1}{/:C}{CRLF}\n{상호} / {사업자} / {대표자}\n{주소}\n{전화번호} / {영수증번호}\n{매출시간} \n------------------------------------------\n{합계금액}\n{할인금액}\n------------------------------------------\n{세액}\n------------------------------------------\n{신용카드}\n{현금영수증}\n{간편결제}\n{회원정보}\n{OKCASHBAG}\n{상품권정보}\n{식권정보}\n{재출력}\n{CUT}'
                }
            };
        }
        // Other types: return basic structure
        const opt = this.prtClsOptions.find((o: any) => o.code === type);
        return {
            templates: [opt ? opt.label : '기본'],
            codes: ['{타이틀}','{LOG}','{상호}','{사업자}','{주소}','{CRLF}','{CUT}'],
            defaults: {}
        };
    }

    private generatePrtViewer(editContent: string): string {
        const sampleMap: any = {
            '{LOG}': '[로고 이미지]',
            '{타이틀}': '{타이틀}',
            '{상호}': '(주)한성정보(보미)',
            '{사업자}': '305-86-14456',
            '{주소}': '대전 동구 우암로277번길 132 (가양동)1호',
            '{대표자}': '박재형',
            '{전화번호}': '042-637-3100',
            '{매출시간}': '2026-04-13 오전 10:32:39',
            '{POSNO}': '01',
            '{계산원}': '김철수',
            '{영수증번호}': '20090101-01-0001',
            '{CRLF}': '',
            '{CUT}': '\n-------------- 절  취  선 --------------',
            '{SIGN}': '\n                              홍  길  동\n              전 자 서 명:________________',
            '{BARCODE}': '\n[바코드 이미지]',
            '{FONT1}': '', '{FONT2}': '', '{FONT3}': '', '{FONT4}': '',
            '{재발행여부}': '',
            '{상품리스트1}': '상품명               단가   수량     금 액\n------------------------------------------\n스테이크(Well done)\n012345678          25,000      1    25,000\n스파게티\n987654780           5,000      1     5,000',
            '{합계금액}': '합 계  금 액                        30,000',
            '{할인금액}': '할 인  금 액                        10,000',
            '{세액}': '           *부가세 면세물품가액      1,000\n            부가세 과세물품가액      2,000\n            부       가      세        200',
            '{받을금액}': '받 을  금 액                        20,000',
            '{받은금액}': '받 은  금 액                       456,789',
            '{거스름}': '거 스  름 돈                       123,456',
            '{결제리스트}': '\n현    금                            30,000\n신용카드                                 0\n포 인 트                                 0\n상 품 권                                 0\n외    상                                 0\n식    권                                 0',
            '{현금영수증}': '     *** 현금영수증(소득공제)[1] ***\n\n확 인  번 호:                 011-***-4444\n승 인  번 호: 123456789             30,000\n------------------------------------------\n알       림 : 현금 영수증 문의 (126)\n홈 페 이 지 : http://현금영수증.kr',
            '{신용카드}': '    *** 신용승인정보(고객용)[1] ***\n\n카 드 종 류:                현대마스터일반\n카 드 번 호:           1234-5678-****-1234\n승 인 금 액: 일시불                 30,000\n승 인 번 호: 현대카드           1234567890\n승 인 일 시:           2009-01-21 13:23:20\n가맹점 번호:                    1234567890',
            '{간편결제}': '        *** 간편결제정보[1] ***\n\n결 제 종 류:                        00페이\n카 드 번 호:              123456**********\n승 인 금 액: 일시불                 30,000\n승 인 번 호: 현대카드           1234567890\n승 인 일 시:           2009-01-21 13:23:20\n가맹점 번호:                    1234567890',
            '{회원정보}': '          *** 회원정보[1] ***\n회원번호             123456789***  OKPOS님\n적립포인트      잔여포인트      사용포인트\n       300         100,000               0',
            '{OKCASHBAG}': '',
            '{별도-신용승인전표-타이틀}': '*** 신용승인정보(고객용)[1] ***',
            '{별도-신용승인전표-내역}': '\n카 드 종 류:                현대마스터일반\n카 드 번 호:           1234-5678-****-1234\n승 인 금 액: 일시불                 30,000\n승 인 번 호: 현대카드           1234567890\n승 인 일 시:           2009-01-21 13:23:20\n가맹점 번호:                    1234567890',
            '{별도-신용승인전표-합계}': '합 계  금 액:                       30,000',
            '{DATETIME}': '2026-04-13 10:32:39',
            '{상품권정보}': '',
            '{상품권정보1}': '',
            '{식권정보}': '',
            '{재출력}': '',
            '{상품리스트2}': '상품명               단가   수량     금 액\n------------------------------------------\n스테이크             25,000      1    25,000\n스파게티              5,000      1     5,000'
        };
        let result = editContent;
        // Remove formatting codes like {:C42}...{/:C}, {:R20}...{/:R}
        result = result.replace(/\{:C\d*\}(.*?)\{\/:C\}/g, '$1');
        result = result.replace(/\{:R\d*\}(.*?)\{\/:R\}/g, '$1');
        result = result.replace(/\{:L\d*\}(.*?)\{\/:L\}/g, '$1');
        // Replace known codes
        for (const [code, value] of Object.entries(sampleMap)) {
            result = result.split(code).join(value as string);
        }
        return result;
    }

    // ===== 매장정보 - 시간대분류/고객수구분 =====
    public toggleTimeSelectAll() {
        this.storeTimeSlots.forEach(s => s.selected = this.storeTimeSelectAll);
        this.service.render();
    }

    public addTimeSlot() {
        this.storeTimeSlots.push({ selected: false, name: '', startTime: '0', endTime: '0' });
        this.service.render();
    }

    public deleteSelectedTimeSlots() {
        this.storeTimeSlots = this.storeTimeSlots.filter((s: any) => !s.selected);
        this.storeTimeSelectAll = false;
        this.service.render();
    }

    public async saveTimeSlots() {
        await this.service.modal.show({ title: '', message: '시간대분류가 저장되었습니다.', cancel: false, action: '확인', status: 'success' });
    }

    public async saveCustomerTypes() {
        await this.service.modal.show({ title: '', message: '고객수 구분이 저장되었습니다.', cancel: false, action: '확인', status: 'success' });
    }

    // ===== 사원정보조회 =====
    public async loadEmployeeInquiry() {
        this.empInqResults = [];
        await this.service.render();
    }

    public async searchEmployeeInquiry() {
        let res = await wiz.call("employee_list", { text: this.empInqSearchValue, page: 1, dump: this.empInqRowCount });
        if (res.code === 200) this.empInqResults = res.data?.data || [];
        await this.service.render();
    }

    // ===== 패스워드변경 (확장) =====
    public initPasswordForm() {
        this.pwForm = { current: '', newpw: '', confirm: '' };
        this.pwCurrentError = '';
        this.pwNewError = '';
        this.pwConfirmError = '';
    }

    public validateNewPassword() {
        const pw = this.pwForm.newpw;
        const regex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@$*]).{8,10}$/;
        if (pw && !regex.test(pw)) {
            this.pwNewError = '영문자, 숫자, 특수문자(!,@,$,*)를 포함하여 8~10자로 작성해주세요.';
        } else {
            this.pwNewError = '';
        }
        this.validateConfirmPassword();
        this.service.render();
    }

    public validateConfirmPassword() {
        if (this.pwForm.confirm && this.pwForm.confirm !== this.pwForm.newpw) {
            this.pwConfirmError = '신규 패스워드와 일치하지 않습니다.';
        } else {
            this.pwConfirmError = '';
        }
        this.service.render();
    }

    public async changePasswordExtended() {
        this.pwCurrentError = '';
        if (!this.pwForm.current) { this.pwCurrentError = '현재 패스워드를 입력하세요.'; await this.service.render(); return; }
        if (this.pwNewError || this.pwConfirmError) return;
        if (!this.pwForm.newpw) { this.pwNewError = '신규 패스워드를 입력하세요.'; await this.service.render(); return; }
        if (!this.pwForm.confirm) { this.pwConfirmError = '패스워드 확인을 입력하세요.'; await this.service.render(); return; }
        let res = await wiz.call("change_password", { current: this.pwForm.current, newpw: this.pwForm.newpw });
        if (res.code === 200) {
            await this.service.modal.show({ title: '', message: '패스워드가 변경되었습니다.', cancel: false, action: '확인', status: 'success' });
            this.initPasswordForm();
        } else {
            this.pwCurrentError = '현재 패스워드가 올바르지 않습니다.';
        }
        await this.service.render();
    }

    // ===== 테이블속성 =====
    public async resetTableProperties() {
        let result = await this.service.modal.show({ title: '테이블속성 초기화', message: '테이블 속성을 초기화합니다. 초기화 하시겠습니까?', cancel: '취소', action: '확인', status: 'warning' });
        if (result) {
            await this.service.modal.show({ title: '', message: '테이블 속성이 초기화되었습니다.', cancel: false, action: '확인', status: 'success' });
        }
    }

    // ===== 포스기능정의 =====
    public initPosFunc() {
        this.posFuncTab = 'usage';
        this.posFuncSelectedGroup = '';
        this.posFuncAuthSelectedGroup = '';
    }

    public selectPosFuncGroup(name: string) {
        this.posFuncSelectedGroup = name;
        this.service.render();
    }

    public selectPosFuncAuthGroup(name: string) {
        this.posFuncAuthSelectedGroup = name;
        this.service.render();
    }

    public getPosFuncFeatures(group?: string): any[] {
        const g = group || this.posFuncSelectedGroup;
        const raw = this.posFuncDataMap[g];
        if (!raw) return [];
        return raw.map((item: any, idx: number) => ({ no: idx + 1, code: String(item[0]).padStart(3, '0'), name: item[1], used: false, auth: false, authOwner: false, authSales: false, authServing: false, authDelivery: false }));
    }

    public getPosFuncAuthFeatures(): any[] {
        const g = this.posFuncAuthSelectedGroup;
        if (!g) return [];
        return this.getPosFuncFeatures(g);
    }

    // ===== 바코드출력환경 =====
    public async loadBarcodeEnvData() {
        let res = await wiz.call("barcode_env_list");
        if (res.code === 200) {
            let all = res.data?.data || [];
            this.bcEnvSamples = all.filter((e: any) => e.is_sample === 'Y');
            this.bcEnvActuals = all.filter((e: any) => e.is_sample !== 'Y');
        }
        await this.service.render();
    }

    public async selectBarcodeEnv(env: any) {
        let res = await wiz.call("barcode_env_get", { id: env.id });
        if (res.code === 200 && res.data?.data) {
            this.bcEnvForm = res.data.data;
            this.bcEnvSelectedId = env.id;
            this.bcEnvPrtDat = [];
            for (let i = 1; i <= 5; i++) {
                let key = `prt_dat_0${i}`;
                let val = this.bcEnvForm[key];
                if (typeof val === 'string') { try { val = JSON.parse(val); } catch { val = {}; } }
                this.bcEnvPrtDat.push({
                    f: val?.f || '', a: val?.a || '0', prefix: val?.prefix || '', suffix: val?.suffix || '',
                    x: val?.x || 0, y: val?.y || 0, w: val?.w || 1, h: val?.h || 0,
                    r: val?.r || '0', b: val?.b || '0', t: val?.t || ''
                });
            }
        }
        await this.service.render();
    }

    public async newBarcodeEnv() {
        this.bcEnvForm = { name: '', printer_nm: '', printer_mode: '1', printer_speed: '2', printer_darkness: '2', port_type: 'W', port_no: '', port_rate: '2', port_data_bit: '8', port_parity_bit: '0', port_stop_bit: '1', cut_use_fg: '0', cut_per_page: 0, cut_stop_pos: 0, paper_type: '0', paper_direction: '0', paper_feed_len: 0, paper_gab: 244, paper_width: 320, paper_height: 184, paper_top_mg: 0, paper_left_mg: 0, paper_font_nm: '굴림체', prod_nm_f: '', prod_nm_1: '', prod_nm_2: '', prod_nm_x: 0, prod_nm_y: 0, prod_nm_w: 0, prod_nm_h: 0, prod_nm_r: '0', prod_nm_b: '0', prod_nm_t: '', uprice_a: '', uprice_1: '', uprice_2: '', uprice_x: 0, uprice_y: 0, uprice_w: 0, uprice_h: 0, uprice_r: '0', uprice_b: '0', uprice_t: '', barcode_01_type: '1', barcode_01_f: 'BAR_CD', barcode_01_p: '0', barcode_01_x: 0, barcode_01_y: 0, barcode_01_h: 0, barcode_01_r: '0', bartext_01_fg: '0', bartext_01_x: 0, bartext_01_y: 0, bartext_01_h: 0, bartext_01_r: '0', bartext_01_b: '0', barcode_02_p: '0', barcode_02_x: 0, barcode_02_y: 0, barcode_02_h: 0, barcode_02_r: '0', bartext_02_fg: '0', bartext_02_x: 0, bartext_02_y: 0, bartext_02_h: 0, bartext_02_r: '0', bartext_02_b: '0', barcode_01_t: '', printer_type: '41' };
        this.bcEnvSelectedId = '';
        this.bcEnvPrtDat = Array.from({ length: 5 }, () => ({ f: '', a: '0', prefix: '', suffix: '', x: 0, y: 0, w: 1, h: 0, r: '0', b: '0', t: '' }));
        await this.service.render();
    }

    public async saveBarcodeEnv() {
        if (!this.bcEnvForm.name) { await this.service.modal.show({ title: '', message: '출력환경 명을 입력하세요.', cancel: false, action: '확인', status: 'error' }); return; }
        let formData: any = { ...this.bcEnvForm };
        for (let i = 0; i < 5; i++) {
            formData[`prt_dat_0${i + 1}`] = JSON.stringify(this.bcEnvPrtDat[i]);
        }
        let res = await wiz.call("barcode_env_save", formData);
        if (res.code === 200) {
            await this.service.modal.show({ title: '', message: '저장되었습니다.', cancel: false, action: '확인', status: 'success' });
            await this.loadBarcodeEnvData();
        } else {
            await this.service.modal.show({ title: '', message: res.data?.message || '저장 실패', cancel: false, action: '확인', status: 'error' });
        }
    }

    public async deleteBarcodeEnv(id: string) {
        let confirm = await this.service.modal.show({ title: '', message: '삭제하시겠습니까?', action: '삭제', status: 'error' });
        if (!confirm) return;
        let res = await wiz.call("barcode_env_delete", { id });
        if (res.code === 200) {
            this.bcEnvForm = null;
            this.bcEnvSelectedId = '';
            await this.loadBarcodeEnvData();
        }
    }

    public resetBarcodeEnvForm() {
        this.bcEnvForm = null;
        this.bcEnvSelectedId = '';
        this.bcEnvPrtDat = Array.from({ length: 5 }, () => ({ f: '', a: '0', prefix: '', suffix: '', x: 0, y: 0, w: 1, h: 0, r: '0', b: '0', t: '' }));
        this.service.render();
    }

    public async initBarcodeEnvSamples() {
        let res = await wiz.call("barcode_env_init_samples");
        if (res.code === 200) {
            await this.service.modal.show({ title: '', message: '샘플 데이터가 생성되었습니다.', cancel: false, action: '확인', status: 'success' });
            await this.loadBarcodeEnvData();
        }
    }

    public bcEnvPrinterTypeLabel(): string {
        if (!this.bcEnvForm) return '';
        const map: any = { '41': 'Bixolon', '02': 'Godex(EZ)', '03': 'LUKHAN', '04': 'TEC', '05': 'TSC', '06': '기타' };
        return map[this.bcEnvForm.printer_type] || 'Auto';
    }

    public async testPrintBarcodeEnv() {
        if (!this.bcEnvForm) { await this.service.modal.show({ title: '', message: '출력환경을 선택하세요.', cancel: false, action: '확인', status: 'error' }); return; }
        await this.service.modal.show({ title: '', message: `테스트 인쇄를 ${this.bcEnvPrintQty}매 수행합니다.`, cancel: false, action: '확인', status: 'success' });
    }

    // ===== 바코드출력 =====
    public async searchBarcodeProducts() {
        let res = await wiz.call("barcode_product_list", this.bcPrintSearch);
        if (res.code === 200) {
            this.barcodeProducts = (res.data?.data || []).map((p: any) => ({ ...p, checked: false, printQty: 0 }));
            this.bcPrintAllChecked = false;
        }
        await this.service.render();
    }

    public async toggleAllBcPrint() {
        for (let p of this.barcodeProducts) p.checked = this.bcPrintAllChecked;
        await this.service.render();
    }

    public async setBulkPrintQty() {
        for (let p of this.barcodeProducts) {
            if (p.checked) p.printQty = this.bcPrintQty;
        }
        await this.service.render();
    }

    public async printBarcode() {
        let items = this.barcodeProducts.filter((p: any) => p.printQty > 0);
        if (items.length === 0) { await this.service.modal.show({ title: '', message: '인쇄할 상품이 없습니다. 인쇄수를 설정하세요.', cancel: false, action: '확인', status: 'error' }); return; }
        if (!this.bcPrintEnvId) { await this.service.modal.show({ title: '', message: '바코드 출력환경을 선택하세요.', cancel: false, action: '확인', status: 'error' }); return; }
        await this.service.modal.show({ title: '', message: `${items.length}건의 상품을 인쇄합니다.`, cancel: false, action: '확인', status: 'success' });
    }
}

export default PageBasicComponent;